import type { Product } from '@mc/api'
import { getMetaCatalogProductProps } from './getMetaCatalogProductProps'

/**
 * The Meta catalog product props plus the explicit AddToCart signals, shared by
 * the purchase-click events.
 *
 * The explicit signals are load-bearing: without them Meta's automatic mapping
 * ignores `product_id`/`contents` and falls back to the generic
 * `product: 'core'` property (injected on every event), which breaks the
 * Catalog AddToCart match rate. `content_ids` carries the single resolved id
 * (Meta catalog cookie or default plan), same as `product_id`.
 *
 * Per the Core Gold Standards Spec, whenever `content_ids`/`contents.id` are
 * populated the matching value fields must be too — hence `currency` and
 * `value` travel with them. `value` is omitted when the product has no LTV.
 *
 * `content_ids` must be omitted rather than sent as `[null]` when no id
 * resolves: it holds an array element, so unlike `product_id` and
 * `contents[].id` it does not disappear through JSON serialization.
 */
export const getMetaAddToCartProps = (
  product?: Product | null,
  isGift = false,
  contentType?: string,
) => {
  const catalogProps = getMetaCatalogProductProps(product, isGift)
  const value = catalogProps.contents[0]?.price

  return {
    ...catalogProps,
    ...(catalogProps.product_id != null && {
      content_ids: [catalogProps.product_id],
    }),
    content_type: contentType || 'product',
    currency: 'USD',
    ...(value != null && { value }),
  }
}
